//User Store
export const USER_SET = '[User] Set User'
export const USER_LOGIN = '[User] Login User'
export const USER_LOGOUT = '[User] Logout User'
